import React from "react";
import qrImage from "../../images/LandingPageImage/chaafo_qr_code_demo.webp";

export const Scanner = () => {
  return (
    <div className="demo-wrap bg-gradient-to-r from-[#0b6b54] to-[#00b46a] py-16 px-4">
      <div className="demo-container max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-12">
        <div className="demo-left text-white max-w-xl">
          <span className="demo-tag text-xs tracking-widest opacity-80">
            LIVE DEMO
          </span>

          <h2 className="demo-title text-3xl md:text-4xl font-bold mt-3 mb-5 leading-tight">
            Try WhatsApp Ordering Instantly
          </h2>

          <p className="demo-text text-base leading-relaxed opacity-95">
            Scan the QR code to explore the menu directly on WhatsApp. No
            downloads needed—simply place an order and experience how effortless
            ordering can be.
          </p>
        </div>

        {/* Right QR */}
        <div className="demo-right flex items-center justify-center">
          <div className="qr-box bg-white rounded-xl p-4 shadow-md">
            <img
              src={qrImage}
              alt="WhatsApp Ordering QR"
              className="w-56 h-56 object-contain"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
